import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { Grid } from '@alfa-bank/site-grid-universal';

import { prepareDate } from '../../helpers';

import styles from './styles/styles.css';
import type { TDateTab } from './models';

export const DateChips: FC<TDateTab> = ({ Text, active, className, date, onClick }) => {
    const { day, dayLabelFull, dayLabelShort, monthLabel } = prepareDate(date);

    const activeChipsContent = (
        <Grid alignment colAutoWidth collapse flexDirection="column">
            <Grid alignment="baseline" colAutoWidth collapse>
                <Text styler={{ margin: 0 }} theme="dark" view="primary-large">
                    {day}{' '}
                </Text>
                <Text styler={{ margin: 0 }} theme="dark" view="secondary-medium">
                    {monthLabel}
                </Text>
            </Grid>
            <Text styler={{ margin: 0 }} theme="dark" view="secondary-medium">
                {dayLabelFull}
            </Text>
        </Grid>
    );

    const commonChipsContent = (
        <Grid alignment colAutoWidth collapse flexDirection="column">
            <Text styler={{ margin: 0 }} view="primary-large">
                {day}
            </Text>
            <Text styler={{ margin: 0 }} view="secondary-medium">
                {dayLabelShort}
            </Text>
        </Grid>
    );

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div
            className={cn(
                styles.external,
                styles.tabRoot,
                {
                    [styles.tabDate]: !active,
                    [styles.tabDateActive]: active,
                },
                className
            )}
            onClick={onClick}
        >
            {active ? activeChipsContent : commonChipsContent}
        </div>
    );
};
